import { ConnectorServiceEnum } from '@enum/connector-service.enum';
import { FieldInterface } from '@interface/form/base-form.interface';

export const getIntegrationFields = (serviceId: ConnectorServiceEnum): FieldInterface[] => {
  switch (serviceId) {
    case ConnectorServiceEnum.BambooHR:
    case ConnectorServiceEnum.Hexnode:
      return [
        {
          label: 'Domain',
          name: ['settings', 'domain'],
          placeholder: 'Please input domain',
        },
        {
          label: 'Api Key',
          name: ['settings', 'apiKey'],
          placeholder: 'Please input apiKey',
        },
      ];
    case ConnectorServiceEnum.Sap:
      return [
        {
          label: 'Domain',
          name: ['settings', 'domain'],
          placeholder: 'Please input domain',
          type: 'sap',
        },
        {
          label: 'Api Key',
          name: ['settings', 'apiKey'],
          placeholder: 'Please input apiKey',
        },
      ];
    case ConnectorServiceEnum.Jamf:
      return [
        {
          label: 'Instance',
          name: ['settings', 'instance'],
          placeholder: 'Please input instance name',
          type: 'jamf',
        },
        {
          label: 'Username',
          name: ['settings', 'username'],
          placeholder: 'Please input username',
        },
        {
          label: 'Password',
          name: ['settings', 'password'],
          placeholder: 'Please input password',
          type: 'password',
        },
      ];
    case ConnectorServiceEnum.Teamtailor:
    case ConnectorServiceEnum.Inrego:
      return [
        {
          label: 'API Key',
          name: ['settings', 'apiKey'],
          placeholder: 'Please input API Key',
        },
      ];
    case ConnectorServiceEnum.Velory:
      return [
        {
          label: 'Email',
          name: ['settings', 'email'],
          placeholder: 'Please input email',
        },
        {
          label: 'Password',
          name: ['settings', 'password'],
          placeholder: 'Please input password',
          type: 'password',
        },
        {
          label: 'Domain',
          name: ['settings', 'domain'],
          placeholder: 'Please input domain',
          type: 'velory',
        },
      ];
    case ConnectorServiceEnum.Postnord:
      return [
        {
          label: 'API Key',
          name: ['settings', 'apiKey'],
          placeholder: 'Please input API Key',
        },
      ];
    case ConnectorServiceEnum.Bring:
      return [
        {
          label: 'Login',
          name: ['settings', 'login'],
          placeholder: 'Please input login',
        },
        {
          label: 'API Key',
          name: ['settings', 'apiKey'],
          placeholder: 'Please input API Key',
        },
      ];
    case ConnectorServiceEnum.Fedex:
      return [
        {
          label: 'Client ID',
          name: ['settings', 'clientId'],
          placeholder: 'Please input client ID',
        },
        {
          label: 'Client secret',
          name: ['settings', 'clientSecret'],
          placeholder: 'Please input client secret',
        },
      ];
    case ConnectorServiceEnum.Hibob:
      return [
        {
          label: 'Service User ID',
          name: ['settings', 'serviceUserId'],
          placeholder: 'Please input service user ID',
        },
        {
          label: 'Service token',
          name: ['settings', 'serviceUserToken'],
          placeholder: 'Please input service token',
        },
      ];
    case ConnectorServiceEnum.Posti:
      return [
        {
          label: 'API Key',
          name: ['settings', 'apiKey'],
          placeholder: 'Please input API Key',
        },
        {
          label: 'API Secret',
          name: ['settings', 'apiSecret'],
          placeholder: 'Please input API Secret',
        },
      ];
    case ConnectorServiceEnum.AlexisHR:
    case ConnectorServiceEnum.HaileyHR:
    case ConnectorServiceEnum.Deel:
      return [
        {
          label: 'Access Token',
          name: ['settings', 'accessToken'],
          placeholder: 'Please input Access Token',
        },
        {
          label: 'Environment',
          name: ['settings', 'env'],
          placeholder: 'Please input environment',
        },
      ];
    case ConnectorServiceEnum.Netset:
      return [
        {
          label: 'Retailer',
          name: ['settings', 'retailer'],
          placeholder: 'Please input retailer',
        },
        {
          label: 'Customer Number',
          name: ['settings', 'customerNumber'],
          placeholder: 'Please input customer number',
        },
        {
          label: 'Currency code',
          name: ['settings', 'currency'],
          placeholder: 'Please input currency code (should be a ISO code SEK, EUR, etc.)',
        },
      ];
    case ConnectorServiceEnum.Webmercs:
      return [
        {
          label: 'Retailer',
          name: ['settings', 'retailer'],
          placeholder: 'Please input retailer identifier',
          optional: true,
        },
        {
          label: 'Domain',
          name: ['settings', 'domain'],
          placeholder: 'Please input domain',
        },
        {
          label: 'Customer Numbers',
          name: ['settings', 'customerNumber'],
          placeholder: 'Please input customer number',
        },
        {
          label: 'Username',
          name: ['settings', 'username'],
          placeholder: 'Please input username',
        },
        {
          label: 'Password',
          name: ['settings', 'password'],
          placeholder: 'Please input password',
          type: 'password',
        },
      ];
    case ConnectorServiceEnum.Elisa:
      return [
        {
          label: 'Domain',
          name: ['settings', 'domain'],
          placeholder: 'Please input domain',
        },
        {
          label: 'Api Key',
          name: ['settings', 'apiKey'],
          placeholder: 'Please input apiKey',
        },
        {
          label: 'Agreement ID',
          name: ['settings', 'agreementId'],
          placeholder: 'Please input agreement ID',
        },
        {
          label: 'Billing account ID',
          name: ['settings', 'billingAccountId'],
          placeholder: 'Please input billing account ID',
        },
      ];
    case ConnectorServiceEnum.TeliaLt:
      return [
        {
          label: 'Username',
          name: ['settings', 'username'],
          placeholder: 'Please input username',
        },
        {
          label: 'Password',
          name: ['settings', 'password'],
          placeholder: 'Please input password',
          type: 'password',
        },
        {
          label: 'Base Path',
          name: ['settings', 'basePath'],
          placeholder: 'b2b-telia-lithuania-mobility-management-sandbox',
        },
        {
          label: 'Unit ID',
          name: ['settings', 'unitId'],
          placeholder: 'Please input unit ID',
        },
        {
          label: 'Domain',
          name: ['settings', 'domain'],
          placeholder: 'api-garden-test',
        },
      ];
    case ConnectorServiceEnum.TeliaNo:
      return [
        {
          label: 'Username',
          name: ['settings', 'username'],
          placeholder: 'Please input username',
        },
        {
          label: 'Password',
          name: ['settings', 'password'],
          placeholder: 'Please input password',
          type: 'password',
        },
        {
          label: 'Client ID',
          name: ['settings', 'clientId'],
          placeholder: 'Please input client ID',
        },
        {
          label: 'Billing Account ID',
          name: ['settings', 'billingAccountId'],
          placeholder: 'Please input billing account ID',
        },
        {
          label: 'Domain',
          name: ['settings', 'domain'],
          placeholder: 'api-garden.teliacompany.com',
        },
      ];
    case ConnectorServiceEnum.Tele2Se:
      return [
        {
          label: 'Username',
          name: ['settings', 'username'],
          placeholder: 'Please input username',
        },
        {
          label: 'Password',
          name: ['settings', 'password'],
          placeholder: 'Please input password',
          type: 'password',
        },
        {
          label: 'Environment',
          name: ['settings', 'env'],
          placeholder: 'Please input environment',
        },
        {
          label: 'Access Token',
          name: ['settings', 'accessToken'],
          placeholder: 'Please input access token',
        },
        {
          label: 'Buyer ID',
          name: ['settings', 'buyerId'],
          placeholder: 'Please input buyer ID',
        },
        {
          label: 'Webhook authorization token',
          name: ['settings', 'webhookAuthToken'],
          placeholder: 'Please input webhook auth token',
        },
      ];
    case ConnectorServiceEnum.Tele2SeHardware:
      return [
        {
          label: 'Organization Number',
          name: ['settings', 'organizationNumber'],
          placeholder: 'Please input organization number',
        },
        {
          label: 'Customer Number',
          name: ['settings', 'customerNumber'],
          placeholder: 'Please input customer number',
        },
        {
          label: 'Contract Number',
          name: ['settings', 'contractNumber'],
          placeholder: 'Please input contract number',
        },
        {
          label: 'Environment',
          name: ['settings', 'env'],
          placeholder: 'Please input environment',
        },
      ];
    case ConnectorServiceEnum.Markit:
      return [
        {
          label: 'Customer Number',
          name: ['settings', 'customerNumber'],
          placeholder: 'Please input customer number',
        },
      ];
    case ConnectorServiceEnum.TdSynnex:
      return [
        {
          label: 'Authorization code',
          name: ['settings', 'authCode'],
          placeholder: 'Please input authorization code',
        },
        {
          label: 'Customer Number',
          name: ['settings', 'customerNumber'],
          placeholder: 'Please input customer number',
        },
        {
          label: 'Environment',
          name: ['settings', 'env'],
          placeholder: 'Please input environment',
        },
      ];
    case ConnectorServiceEnum.AppleBusiness:
      return [
        {
          label: 'Client ID',
          name: ['settings', 'clientId'],
          placeholder: 'Please input client ID',
        },
        {
          label: 'Key ID',
          name: ['settings', 'keyId'],
          placeholder: 'Please input key ID',
        },
        {
          label: 'Team ID',
          name: ['settings', 'teamId'],
          placeholder: 'Please input team ID',
        },
        {
          label: 'Private Key',
          name: ['settings', 'privateKey'],
          placeholder: '',
          type: 'file',
        },
      ];
    default:
      return [];
  }
};
